const quotationMarksPattern = /^"|"$/g,
    breaklinesPattern = /\n/g;

export function sanitizeJson(jsonString: any): any {
    try {
        const sanitizeJsonString = jsonString.replace(quotationMarksPattern, '')
            .replace(breaklinesPattern, '\\n');
        const parsedJSON = JSON.parse(sanitizeJsonString);
        return parsedJSON;
    } catch {
        return jsonString;
    }
}

export function checkJsonObject(obj: string): boolean{

    try{
        // Se deben remover los las d
        obj = obj.replace(quotationMarksPattern, '')
            .replace(breaklinesPattern, '\\n');
        // Luego se intenta parsear
        JSON.parse(obj);

        return true;
    }catch(e){
        return false;
    }

}

export function checkIsArray(obj: any): boolean{

    return Array.isArray(obj);

}
